(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    if(root.__hcInit) return; root.__hcInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var slides = [].slice.call(root.querySelectorAll('.hc__slide'));
    var dotsWrap = root.querySelector('.hc__dots');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    //if (reduce) autoplay = false;
    var parallax = root.getAttribute('data-parallax') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var idx = 0, timer = null, paused = false;

    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); rearm(); });
        dotsWrap.appendChild(b);
      });
    }
    var dots = dotsWrap ? [].slice.call(dotsWrap.children) : [];

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === idx); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      root.style.setProperty('--hc-nav', (slides[idx] && slides[idx].getAttribute('data-tc') === 'light') ? '#F6F3EE' : '#171511');
    }
    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }
    function rearm() { if (timer) { clearInterval(timer); timer = null; } if (autoplay && !paused && slides.length > 1) timer = setInterval(next, speed); }

    var pv = root.querySelector('.hc__arrow.prev'), nx = root.querySelector('.hc__arrow.next');
    if (nx) nx.addEventListener('click', function () { next(); rearm(); });
    if (pv) pv.addEventListener('click', function () { prev(); rearm(); });
    var pauseBtn = root.querySelector('.hc__pause');
    if (pauseBtn) {
      if (!autoplay) { pauseBtn.hidden = true; }
      else pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.classList.toggle('is-paused', paused);
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        if (paused) { if (timer) { clearInterval(timer); timer = null; } } else { rearm(); }
      });
    }
    function hold() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', hold);
    root.addEventListener('mouseleave', rearm);
    root.addEventListener('focusin', hold);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) rearm(); });
    go(0); rearm();

    if (parallax && !reduce) {
      var ticking = false;
      function frame() {
        var r = root.getBoundingClientRect(), hgt = root.offsetHeight || 1, y = -r.top;
        if (y > -hgt && y < hgt) {
          root.style.setProperty('--py1', (y * 0.34) + 'px');
          root.style.setProperty('--py2', (y * 0.12) + 'px');
          root.style.setProperty('--capop', Math.max(0, 1 - (Math.max(0, y) / (hgt * 0.72))).toFixed(3));
        }
        ticking = false;
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      frame();
    }
  }
  function initAll() { document.querySelectorAll('.hc').forEach(function (r) { initHero(r); }); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-marquee"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.__rvInit) return; root.__rvInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var rt = root.querySelector('.rv__track');
    if (rt && !reduce) {
      [].slice.call(rt.children).forEach(function (n) { rt.appendChild(n.cloneNode(true)); });
    }
  }
  function all(){ document.querySelectorAll('.rv').forEach(function (r) { init(r); }); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();
})();
